import React from "react";
import { useSelector } from "react-redux";
import { buildCardHeaderColorCss } from "../../../constant/BoardSections";

const CardHeaderColorStyles = () => {
    const cardHeaderColors = useSelector((state) => state.subDomain?.subDomainData?.card_header_colors);
    const css = buildCardHeaderColorCss(cardHeaderColors);
    if (!css) {
        return null;
    }
    return <style>{css}</style>;
};

export default CardHeaderColorStyles;
